import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

const WAIT_INTERVAL = 1000;

const Numberbox = React.memo((props) => {
    const [value, setValue] = useState('');
    const [timer, setTimer] = useState(null);

    useEffect(() => {
        setValue(props.formHandler.values[props.name]);
    }, [props.formHandler.values[props.name]]);

    const handleChange = (e) => {
        clearTimeout(timer);
        setTimer(null);
        const value = e.target.value;
        const name = e.target.name;
        if (!isNaN(value)) {
            setValue(Number(value))
            let localTimer = setTimeout(() => triggerChange({ target: { value: Number(value), name: name } }), WAIT_INTERVAL);
            setTimer(localTimer);
        }
    };

    const triggerChange = (e) => {
        props.formHandler.handleChange(e);
        clearTimeout(timer);
        setTimer(null);
    };

    const touched = props.formHandler.errors[props.name];
    const errors = props.formHandler.errors[props.name];

    return (
        <>
            <Form.Label disabled={props.disabled} className={props.label ?? "d-none"}>{props.label}</Form.Label>
            <Form.Control
                disabled={props.disabled}
                type={"text"}
                className={props.className}
                placeholder={props.placeholder}
                value={value}
                onChange={(e) => handleChange(e)}
                onBlur={props.formHandler.handleBlur}
                name={props.name}
                isInvalid={touched && errors}
            />
            <Form.Control.Feedback disabled={props.disabled} type="invalid">{errors}</Form.Control.Feedback>
        </>
    );
})

export default Numberbox;